import React from 'react';
import PropTypes from 'prop-types';

const PageTitle = ({ text = 'Default Title', className='app-page-title' }) => {
  return (
    <h1 className={className}>
      {text}
    </h1>
  );
};

PageTitle.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default PageTitle;